import React from 'react';
import { LinkSection as LinkSectionType } from '../../types/familyLinks';
import { LinkItem } from '../../types/familyLinks';
import LinkTile from './LinkTile';

interface LinkSectionProps {
  section: LinkSectionType;
  onAdd: (category: string) => void;
  onEdit: (link: LinkItem, category: string) => void;
  onDelete: (link: LinkItem) => void;
}

const LinkSection: React.FC<LinkSectionProps> = ({ section, onAdd, onEdit, onDelete }) => {
  return (
    <section className="family-links-section">
      <header className="family-links-section-header">
        <h2 className="family-links-section-title">{section.title.toLowerCase()}</h2>
        <span className="family-links-section-count">{section.links.length}</span>
      </header>
      <div className="family-links-tiles-grid">
        {section.links.map(link => (
          <LinkTile
            key={link.id}
            link={link}
            onEdit={(l) => onEdit(l, section.title)}
            onDelete={onDelete}
          />
        ))}
        <button
          type="button"
          className="family-links-tile family-links-tile-add"
          onClick={() => onAdd(section.title)}
          aria-label="Add new link"
        >
          <div className="family-links-tile-add-inner">+</div>
        </button>
      </div>
    </section>
  );
};

export default LinkSection;
